export default function (context) {
  try {
    if (process.client && window.analytics?.page) {
      window.analytics.page(context.route.path)
    } else {
      console.log('not using analytics')
    }
  } catch (e) {
    console.error(e)
  }
}
